import { Role } from '@/model/role';
import type { RouteRecordRaw } from 'vue-router';

const Locations = () => import('@/components/locations/Locations.vue');

const locationsRoutes: RouteRecordRaw[] = [
  {
    path: '/locations',
    name: 'Locations',
    component: Locations,
    meta: {
      role: Role.ADMIN,
    },
  },
];

export default locationsRoutes;
